import React, { forwardRef, useContext } from 'react'
import { PostPurchaseContext, PostPurchaseDispatchContext } from '../context/PostPurchaseContext';

const FormSelect = forwardRef(function FormSelect(props, ref) {
    const { errorMessage, label, options, name } = props;
    const inputErrorClasses = ["outline", "outline-2", "outline-[#FD6F64]"]
    const labelErrorClasses = ["after:content-[attr(data-error-msg)]", "before:content-[attr(data-error-icon)]"]
    const state = useContext(PostPurchaseContext);
    const dispatch = useContext(PostPurchaseDispatchContext);
    function handleSelectChange({ target }) {
        ref.current.classList.remove(...inputErrorClasses)
        ref.current.parentElement.classList.remove(...labelErrorClasses)
        ref.current.parentElement.classList.add("before:content-none")

        dispatch({ type: 'setCustomerData', payload: { name: [target.name], value: target.value } })
    }
    return (
        <label
            data-error-icon="!"
            data-error-msg={errorMessage}
            className="flex-1 w-5/6  relative after:z-10 after:absolute after:bottom-0 after:text-[#FD6F64] after:text-[12px] after:left-0 after:translate-y-full before:absolute before:right-2 before:top-1/2 before:bottom-1/2 before:w-[20px] before:h-[20px] before:rounded-full before:bg-[#FF7062] before:text-white before:content-none before:flex before:items-center before:justify-center"
        >
            <div className="uppercase font-normal after:content-['*'] after:text-brio-200">
                {label}
            </div>
            <div className="relative">
                <select name={name} ref={ref} value={state[name]} onChange={handleSelectChange} className="text-muted-800 min-w-0 w-full py-2 px-4 rounded-xl">
                    <option value="">Select an option</option>
                    {options.map(option => {
                        return(<option key={option.value} value={option.value}>{option.label}</option>)
                    })}

                </select>
                <div className="pointer-events-none absolute right-[4px] -translate-x-1/2 border-b-[3px] border-r-[3px] top-[calc(50%-4px)] -translate-y-1/2 border-brio-800 z-10 w-6 h-6 rotate-45"></div>
            </div>
        </label>
    )
})

export default FormSelect